var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeployed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    stroke: "#3A81F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7428 2.57125C10.7907 3.14247 9.85875 4.29204 9.16686 5.87472C8.47022 7.4683 8 9.53724 8 12H9C9 9.66276 9.44645 7.7317 10.0831 6.27528C10.7246 4.80796 11.5426 3.85753 12.2572 3.42875L11.7428 2.57125ZM8 12C8 14.4628 8.47022 16.5317 9.16686 18.1253C9.85875 19.708 10.7907 20.8575 11.7428 21.4287L12.2572 20.5713C11.5426 20.1425 10.7246 19.192 10.0831 17.7247C9.44645 16.2683 9 14.3372 9 12H8Z",
    fill: "#3A81F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2572 2.57125C14.0976 3.67548 16.5 7.05311 16.5 12H15.5C15.5 7.34689 13.2357 4.32452 11.7428 3.42875L12.2572 2.57125ZM16.5 12C16.5 16.9469 14.0976 20.3245 12.2572 21.4287L11.7428 20.5713C13.2357 19.6755 15.5 16.6531 15.5 12H16.5Z",
    fill: "#3A81F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6746 7.37963C4.34328 7.95278 5.52997 8.47656 6.95849 8.85807C8.40415 9.24415 10.1558 9.5 12 9.5V8.5C10.2442 8.5 8.57919 8.25585 7.21651 7.89193C5.8367 7.52344 4.82338 7.04722 4.3254 6.62037L3.6746 7.37963ZM12 9.5C13.8442 9.5 15.5959 9.24415 17.0415 8.85807C18.47 8.47656 19.6567 7.95278 20.3254 7.37963L19.6746 6.62037C19.1766 7.04722 18.1633 7.52344 16.7835 7.89193C15.4208 8.25585 13.7558 8.5 12 8.5V9.5Z",
    fill: "#3A81F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6746 16.6204C4.34328 16.0472 5.52997 15.5234 6.95849 15.1419C8.40415 14.7559 10.1558 14.5 12 14.5V15.5C10.2442 15.5 8.57919 15.7441 7.21651 16.1081C5.8367 16.4766 4.82338 16.9528 4.3254 17.3796L3.6746 16.6204ZM12 14.5C13.8442 14.5 15.5959 14.7559 17.0415 15.1419C18.47 15.5234 19.6567 16.0472 20.3254 16.6204L19.6746 17.3796C19.1766 16.9528 18.1633 16.4766 16.7835 16.1081C15.4208 15.7441 13.7558 15.5 12 15.5V14.5Z",
    fill: "#3A81F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployed);
export default __webpack_public_path__ + "static/media/deployed.9c341c0a1373cb671c4f5694fa6611ee.svg";
export { ForwardRef as ReactComponent };